import { render, staticRenderFns } from "./QuestionTopicError.vue?vue&type=template&id=9de9d438&scoped=true&"
import script from "./QuestionTopicError.vue?vue&type=script&lang=js&"
export * from "./QuestionTopicError.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTopicError.vue?vue&type=style&index=0&id=9de9d438&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de9d438",
  null
  
)

export default component.exports